// Replaces numbered marker {0} with item based on the index of the item in the markers array
export const replaceMarker = ( text: string, markers: string[] ) => {
    for ( let i = 0; i < markers.length; i++ ) {
        let currentMarker = `{${i}}`;
        text = text.replace( currentMarker, markers[i] )
    }
    return text;
};
